import { type PrimitiveAtom, useAtom } from 'jotai'
import React from 'react'

import {
  DataDisplayTypeSwitcher,
  type DataDisplayTypeSwitcherProps,
} from '~/components/features/DataDisplayTypeSwitcher'
import { type DataDisplayType } from '~/utils'

export type DataDisplayTypeAtomSwitcherProps = Omit<
  DataDisplayTypeSwitcherProps,
  'onChange' | 'value'
> & {
  dataDisplayTypeAtom: PrimitiveAtom<DataDisplayType>
}

export const DataDisplayTypeAtomSwitcher = ({
  dataDisplayTypeAtom,
  ...rest
}: DataDisplayTypeAtomSwitcherProps) => {
  const [dataDisplayType, setDataDisplayType] = useAtom(dataDisplayTypeAtom)

  return (
    <DataDisplayTypeSwitcher
      value={dataDisplayType}
      onChange={setDataDisplayType}
      {...rest}
    />
  )
}
